import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Button, Modal, Tab, Tabs } from 'react-bootstrap'

import ManualPaymentForm from './manualpaymentform'
import SavedCardForm from './savedcardform'

@observer(['globals', 'invoices'])
export default class ProcessPaymentsModal extends Component {

  constructor(props) {
    super(props)

    this.props.invoices.loadInvoiceByToken(props.invoiceToken, false)
  }

  reload(callback) {
    this.props.reload(() => {
        if (callback != null) {
            callback()
        }
    })
  }

  setLoadableState(loadableState) {
    this.props.setLoadableState(loadableState)
  }

  onClose() {
    this.props.onClose()
  }

  render() {
    let savedCardTab = ''
    let manualPaymentTab = ''

    savedCardTab = this.props.invoices.invoiceDetail.stripeCustomerId
    ? (
      <Tab eventKey={1} title="Saved Cards">
        <div>
          <SavedCardForm invoice={this.props.invoices.invoiceDetail} />
        </div>
      </Tab>
    ) : <Tab eventKey={1} title="Saved Cards">
      <div>No Saved Cards On File for Customer.</div>
    </Tab>;

    manualPaymentTab = this.props.invoices.invoiceDetail.id
    ? (
      <Tab eventKey={2} title="Manual">
        <ManualPaymentForm invoice={this.props.invoices.invoiceDetail} onClose={this.onClose.bind(this)} reload={this.reload.bind(this)} setLoadableState={this.setLoadableState.bind(this)} />
      </Tab>
    ) : <Tab eventKey={2} title="Manual">
      <div>Loading...</div>
    </Tab>;

    return (
      <Modal show={this.props.open} onHide={this.props.onClose.bind(this)}>
        <Modal.Header closeButton>
          <Modal.Title>Charge Card On File</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Tabs defaultActiveKey={1} id="payment-method-tabs">
            {savedCardTab}
            {manualPaymentTab}
          </Tabs>
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="danger" onClick={() => { this.props.onClose() }}><i className="fa fa-ban" aria-hidden="true"></i> Cancel</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/invoices/processpaymentsmodal.js